/**
 * The company logo's address (M2-19). The API hands out a path RELATIVE to its
 * own origin (`/api/v1/public/logos/{key}?v={version}`), served anonymously so
 * an `<img>` can load it with no token; this puts the API's origin in front.
 * Empty `VITE_API_BASE_URL` means same-origin, which is what the dev proxy and
 * jsdom both are.
 */
export function logoSrc(path: string | null | undefined): string | null {
  if (!path) return null;
  return `${import.meta.env.VITE_API_BASE_URL ?? ''}${path}`;
}
